export const PARTNER360_PROGRAM_TYPES_CRUD_KEY = 'Partner360ProgramTypes'
